import dynamic from "next/dynamic";
import React, { FC } from "react";

import { useFeatureEnabled } from "@/features/common/hooks/useFeatureEnabled";
import Eth721ActionButton from "@/features/nft/components/Eth721ActionButton";
import { useEth721Ownership } from "@/features/nft/hooks/useEth721Ownership";
import {
  FeatureNameEnum,
  PostDetailFragment,
  PostPagePostFragment,
  UploadWithIntrinsicSizeFragment,
} from "@/generated/generated-hooks";
import { getPublicConfig } from "@/helpers/getPublicConfig";

import { CollectiblePostContent } from "./CollectiblePostContent";

const Eth721History = dynamic(() => import("./Eth721History"), { ssr: false });

// TODO: update post param to compulsory after the ui is done
interface NFTPostContentProps {
  post?: PostDetailFragment &
    PostPagePostFragment & { images?: UploadWithIntrinsicSizeFragment[] };
  isBid?: boolean;
}

/**
 * @purpose render a NFT post
 * @returns conditionally rendered %PostContent Component
 */
export const Eth721PostContent: FC<NFTPostContentProps> = (props) => {
  const {
    service: {
      ethereum: { contractAddress },
    },
  } = getPublicConfig();
  const { post, isBid = false } = props;

  const { isEnabled, loading: loadingFeatures } = useFeatureEnabled();

  const { asset } = post;
  const { isNftOwner, isNftCreator } = useEth721Ownership(asset);

  const nftEnabled = isEnabled(FeatureNameEnum.Nft);

  /**
   * Toggle between menus through the PostContentNavbar
   */

  const getActionButton = () => {
    if (loadingFeatures || !nftEnabled) return null;
    if (isBid) return null;

    return (
      <Eth721ActionButton
        tokenId={post.tokenId}
        loadingAsset={!asset}
        listStatus={asset?.listStatus}
        isNFTOwner={isNftOwner}
        fullWidth={true}
        logEventSource="post-content"
      />
    );
  };

  return (
    <CollectiblePostContent
      nftHistory={<Eth721History tokenId={post.tokenId} />}
      asset={asset}
      post={post}
      actionButton={getActionButton()}
      contractAddress={contractAddress.eth721}
      isNftOwner={isNftOwner}
      isNftCreator={isNftCreator}
    />
  );
};
